export default "__VITE_ASSET__BYtfjDBF__"